import PolicyExcerpt from './PolicyExcerpt';

export default PolicyExcerpt;
